import { IconProps } from './IconProps';

export function CopyIcon(props: IconProps) {
    return (
        <svg
            width="25"
            height="25"
            {...props}
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.5 3.32422H20.5C21.0523 3.32422 21.5 3.77193 21.5 4.32422V7.03122V16.3242C21.5 16.5894 21.3946 16.8438 21.2071 17.0313C21.0196 17.2189 20.7652 17.3242 20.5 17.3242H8.5C8.23478 17.3242 7.98043 17.2189 7.79289 17.0313C7.60536 16.8438 7.5 16.5894 7.5 16.3242V4.32422C7.5 4.059 7.60536 3.80465 7.79289 3.61711C7.98043 3.42958 8.23478 3.32422 8.5 3.32422Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.5 7.32422H4.5C4.23478 7.32422 3.98043 7.42958 3.79289 7.61711C3.60536 7.80465 3.5 8.059 3.5 8.32422V20.3242C3.5 20.5894 3.60536 20.8438 3.79289 21.0313C3.98043 21.2189 4.23478 21.3242 4.5 21.3242H16.5C16.7652 21.3242 17.0196 21.2189 17.2071 21.0313C17.3946 20.8438 17.5 20.5894 17.5 20.3242V17.3242"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.5 7.32422V13.3242"
                stroke="currentColor"
                strokeLinecap="round"
            />
            <path
                d="M11.5 10.3242H17.5"
                stroke="currentColor"
                strokeLinecap="round"
            />
        </svg>
    );
}
